var _path, _path2, _mask, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 5.89543 1.89543 5 3 5H17C18.1046 5 19 5.89543 19 7V16C19 17.1046 18.1046 18 17 18H3C1.89543 18 1 17.1046 1 16V7Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5V3C13 2.44772 12.5523 2 12 2H8C7.44772 2 7 2.44772 7 3V5",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2205_12450",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 6,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 9,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5C10.2761 11.5 10.5 11.7239 10.5 12H7.5C7.5 13.3807 8.61929 14.5 10 14.5V11.5ZM9.5 12C9.5 11.7239 9.72386 11.5 10 11.5V14.5C11.3807 14.5 12.5 13.3807 12.5 12H9.5ZM10 12.5C9.72386 12.5 9.5 12.2761 9.5 12H12.5C12.5 10.6193 11.3807 9.5 10 9.5V12.5ZM10 9.5C8.61929 9.5 7.5 10.6193 7.5 12H10.5C10.5 12.2761 10.2761 12.5 10 12.5V9.5Z",
    fill: "#197C85",
    mask: "url(#path-3-outside-1_2205_12450)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7V10C1 11.1046 1.89543 12 3 12H8.5M19 7V10C19 11.1046 18.1046 12 17 12H11.5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.e4c923c3a3b14b9c8b9ab0592eff9a30.svg";
export { ForwardRef as ReactComponent };